import { Component, Input, OnDestroy, OnInit, Injectable} from '@angular/core';
import { BehaviorSubject, from, Observable, of, Subject, Subscription } from 'rxjs';
import { DocumentService } from '../_services/document.services';
import { HelperServices } from '../_services/helper.services';
import { catchError, exhaustMap, finalize } from 'rxjs/operators';
import { QuoteService } from '../_services/quote.services';
import { Document } from '../_models/document.model';
import { Quote, QuoteDocuments } from '../_models/quote.model';
import { UserModel } from '../../modules/auth/_models/user.model';
import { AuthService } from '../../modules/auth/_services/auth.service';
import { LayoutService } from '../../_metronic/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { NgbModal, ModalDismissReasons, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import {NgbDateStruct, NgbCalendar} from '@ng-bootstrap/ng-bootstrap';
import {NgbDatepickerI18n} from '@ng-bootstrap/ng-bootstrap';
import _, { map } from 'underscore';

const I18N_VALUES = {
    'fr': {
      weekdays: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa', 'Do'],
      months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    }
    // other languages you would support
};

declare var require: any
const FileSaver = require('file-saver');

declare var download: any;

import {
  GroupingState,
  PaginatorState,
  SortState,
  ICreateAction,
  IEditAction,
  IDeleteAction,
  IDeleteSelectedAction,
  IFetchSelectedAction,
  IUpdateStatusForSelectedAction,
  ISortView,
  IFilterView,
  IGroupingView,
  ISearchView,
} from '../../_metronic/shared/crud-table';
import * as _moment from 'moment';

import {  CurrencyPipe, ViewportScroller } from '@angular/common';
import { validateAnyosPagos, validateTermino } from '../_helpers/customvalidator.validator';
import { Router } from '@angular/router';

@Component({
  selector: 'app-quoteslife',
  templateUrl: './quoteslife.component.html',
  styleUrls: ['./quoteslife.component.scss'],
  providers: [CurrencyPipe]
})

export class QuoteslifeComponent implements
  OnInit,
  OnDestroy {
    loadingModalConfig: NgbModalOptions = {
      backdrop : 'static',
      keyboard : false
    };
    permissionMenu: any;
    VerEvaluacionCotizacionVida: boolean = false;
    loadingModal: boolean = false;
    paginator: PaginatorState;
    sorting: SortState;
    grouping: GroupingState;
    isLoading: boolean;
    templateView: number = 1;
    idQuote: number = 0;
    idDocument: number = 0;
    idEntity: number = 0;
    quote_selected: Quote;
    document_selected: Document;
    showComapnyName: boolean = false;
    extrasUserDropdownStyle: 'light' | 'dark' = 'light';
    user$: Observable<UserModel>;
    _user: UserModel;
    hasError: boolean;
    hasLoadindRD: boolean = false;
    isNewQuote: false;
    quoteHasError: boolean;
    genero:any;
    fumador:any;
    tipoPago:any;
    frecuenciaPago:any;
    estatus:any;
    tipoRiesgo:any;
    requiredDocument:any;
    filterQuoteForm: FormGroup;
    fileRequiredForm: FormGroup;
    quoteForm: FormGroup;
    quoteResult: any;
    quoteResult2: any;
    quoteHasSuccess : number = 2;
    closeResult: string;
    activeSubmitFilterQuote: boolean = false;
    
    public targetDiv1: ViewportScroller;
    private subscriptions: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
    public isCollapsed1 = false; //Daypicker
    public isCollapsed2 = false; //Daypicker

    public quoteResultOb$: Observable<any>;
    private quoteResultSubject = new Subject<any>();

    public quoteHasError$: Observable<any>;
    public quoteHasErrorSubject = new Subject<any>();

    public requiredDocument$: Observable<QuoteDocuments[]>;
    public requiredDocumentSubject = new Subject<QuoteDocuments[]>();

    public tipoPago$: Observable<QuoteDocuments>;
    public tipoPagoSubject = new Subject<any>();

    // Default Values
    Calificacion: number = 100;
    Recargo: number = 0;
    TipoRiesgo: number = 0;
    UbicacionRiesgo: string = "-";
    FrecuenciaSelected: string = "";
    SumaAseguraPolizaExistente: number = 0;
    IdTienePolizaVida: boolean = false;


    constructor(
        private router: Router,
        public quoteService: QuoteService,
        public documentService: DocumentService,
        private layout: LayoutService,
        private auth: AuthService,
        private fb: FormBuilder,
        private modalRequiredDocumentos: NgbModal,
        private modalLoading: NgbModal,
        public sanitizer: DomSanitizer,
        public helperServices: HelperServices,
        public calendar: NgbCalendar,
        public currencyPipe : CurrencyPipe
    ) {}
  
    // angular lifecircle hooks
    async ngOnInit() {
        this.permissionMenu = JSON.parse(localStorage.getItem("permissionMenu"))[0];
        if(this.router.url.search("quotes-life-cz") > 0 && this.permissionMenu.VerEvaluacionCotizacionVida == 1) {
            this.VerEvaluacionCotizacionVida = true;
        }

		this.quoteResultOb$ = this.quoteResultSubject.asObservable();
        this.tipoPago$ = this.tipoPagoSubject.asObservable();
		this.quoteHasError$ = this.quoteHasErrorSubject.asObservable();
    	this.requiredDocument$ = this.requiredDocumentSubject.asObservable();
        this.requiredDocument$.subscribe((x) => {
            if(x) {
                this.hasLoadindRD = true;
            }
        });
		this.initForm();
		
		this.genero = this.helperServices.getSexo();
		this.fumador = this.helperServices.getFumador();
		this.tipoRiesgo = this.helperServices.getTipoRiesgo();
    	this.frecuenciaPago = this.helperServices.getFrecuencia();
 	    this.estatus = this.quoteService.getStatus();
		this.extrasUserDropdownStyle = this.layout.getProp(
			'extras.user.dropdown.style'
		);

		this.user$ = this.auth.currentUserSubject.asObservable();
		this.user$.subscribe(user=> {
			this._user = user;
		});

		/*
		this.quoteResultSu.subscribe(x => {
			this.quoteResult = x;
		});
		*/

		this.quoteService.fetch();
		this.paginator = this.quoteService.paginator;

		const sb1 = this.quoteService.isLoading$.subscribe(res => this.isLoading = res);
		this.subscriptions.push(sb1);

   
    }

    ngOnDestroy() {
      this.subscriptions.forEach((sb) => sb.unsubscribe());
      this.quoteResultSubject.unsubscribe();
      this.quoteHasErrorSubject.unsubscribe();
      this.requiredDocumentSubject.unsubscribe();
    }

    async clickView(id = 0, _templateView) {
      var _this = this;

      if(this.isNewQuote) {
        window.location.reload();
      }
      else {
        if(!id){
          return false;
        }
        
        else {
          switch ((this.templateView = _templateView)) {
            case 1:
              this.templateView = _templateView;
              await this.quoteService.patchState({ paramsGet : "" });
              this.quoteResultSubject.next(null);
              break;
            case 2:
              this.idQuote = id;
              var paramsGet = [];
              paramsGet.push(`NroCotizacion=${id}`);
              //await this.quoteService.patchState({ paramsGet : paramsGet.join('&') });
              //this.quote_selected = this.quoteService.items$.toPromise()[0];
              this.quote_selected = this.quoteService.extracData(this.idQuote, this.quoteService.items$);
              this.setQuoteValue(this.quote_selected);
              break;
          }
        }
      }
    }
  
    clickDownloadEstatement(content, IdPoliza) {
      this.modalLoading.open(content, this.loadingModalConfig);
      
    }
  
    d(text) {
  
    }
   
    async clickDownloadDocument(content, id, filename, event) {
      //event.currentTarget.disabled = true;
      this.modalLoading.open(content, this.loadingModalConfig);
  
      var base64String = await this.documentService.get_documents_by(Array(`IdDocumento=${id}`).join('&')).then( (base64String) => {
        const linkSource = `data:application/pdf;base64,${base64String}`;
        const downloadLink = document.createElement("a");
    
        downloadLink.href = linkSource;
        downloadLink.download = filename;
        downloadLink.click();
      }).finally(() => {
        this.modalLoading.dismissAll();
      });
    }
  
    changeFilterMode(event) {
      this.filterQuoteForm = event.target.value;
    }
  
    initForm() {

        var g = this;

        this.quoteResult = {
        SumaAsegurada: 0.00,
        SumaAseguradaContenido: 0.00,
        SumaAseguradaIncendio: 0.00,
        NroAnosPago: 0,
        PrimaMensualBasicaSeguroVida:0,
        RecargoMensualAgravacionRiesgo: 0,
        PrimaMensualAdicionalSeguroVida: 0,
        PrimaMensualBasicaBeneficiosAdicinales: 0,
        PrimaMensualTotalNivelada: 0,
        PrimaAnualTotalNivelada: 0
        };

        this.filterQuoteForm = this.fb.group({
        inputNroCotizacion: [''],
        inputAsegurado: [''],
        inputFechaDesde: [''],
        inputFechaHasta: [''],
        inputEdad: ['',Validators.compose([Validators.pattern("^[0-9]*$")])],
        inputIdEstatus: [''],
        inputAgente: [''],
        inputGrupoEconomico: ['']
        });

        this.quoteForm = this.fb.group({
            inputIdCotizacion: [''],
            inputNroCotizacion: [''],
            inputAsegurado: ['', Validators.compose([Validators.required])],
            //inputFechaNacimiento: ['', Validators.compose([Validators.required])],
            inputIdentificacion: [''],
            inputEdad:  ['', Validators.compose([Validators.required, Validators.min(1), Validators.pattern("^[0-9]*$")])],
            inputSexo: ['', Validators.compose([Validators.required])],
            inputEsFumador: ['', Validators.compose([Validators.required])],
            inputEmail: ['',[Validators.pattern("[^ @]*@[^ @]*")]],
            inputCelular: [''],
            inputClasificacion: [{value: 100, disabled: !this.VerEvaluacionCotizacionVida}, Validators.compose([Validators.required, Validators.min(100), Validators.max(300), Validators.pattern("^[0-9]*$")])],
            inputTermino: ['', Validators.compose([Validators.pattern("^[0-9]*$"),Validators.min(10)])],
            inputTipoRiesgo: [{value: 0, disabled: true}, Validators.compose([Validators.required])],
            inputUbicacionRiesgo: [{value: '', disabled: true}],

            inputSumaAsegurada: ['',Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])],
            inputSumaAseguraPolizaExistente: ['',Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])],
            inputSumaAseguradaContenido: [{value: 0, disabled: true}, Validators.compose([Validators.pattern("^[0-9]*$")]) ],
            inputSumaAseguradaIncendio: [{value: 0.00, disabled: true}, Validators.compose([Validators.pattern("^[0-9]*$")]) ],
            inputNroAnosPago: ['', Validators.compose([Validators.required, Validators.min(1), Validators.pattern("^[0-9]*$")])],
            inputRecargo: [{value: 0, disabled: !this.VerEvaluacionCotizacionVida}, Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])],
            inputIdTipoPago: ['', Validators.compose([Validators.required])],
            inputIdFrecuenciaPago: ['', Validators.compose([Validators.required])],
            inputMotivoRecargo: [''],
            inputIdTienePolizaVida: [false],
        },
        {
            validator: [validateTermino(), validateAnyosPagos()]
        })
    }    

    validInt(a) {
      if(a >= 0) {
        return parseInt(a);
      }
      return 0;
    }

    submitFilterQuote() {
      this.quoteService.patchState({ paramsGet : this.filterQuoteReport() });
    }

    submitFilterQuoteReport(content) {
        this.modalLoading.open(content, this.loadingModalConfig);
        this.quoteService.getDocumentFilterQuote(this.filterQuoteReport()).then(response => {
            if(response) {
                this.helperServices.printPreview2(response, `Cotizacion-Report.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
            }
            else {
                alert("No se pudo generar el documento.")
            }
        }).finally(() => {
            this.modalLoading.dismissAll();
        });
    }

    filterQuoteReport() {
        var paramsGet = [];

        if( (this.filterQuoteForm.value.inputAsegurado)) {
            paramsGet.push(`Asegurado=${this.filterQuoteForm.value.inputAsegurado}`);
        }
        if( (this.filterQuoteForm.value.inputNroCotizacion) ) {
            paramsGet.push(`NroCotizacion=${this.filterQuoteForm.value.inputNroCotizacion}`);
        }
        if( (this.filterQuoteForm.value.inputEdad) ) {
            paramsGet.push(`Edad=${this.filterQuoteForm.value.inputEdad}`);
        }
        if(this.permissionMenu.VerEvaluacionCotizacionVida == 1 && this.filterQuoteForm.value.inputGrupoEconomico ) {
            paramsGet.push(`IdGrupoEconomico=${this.filterQuoteForm.value.inputGrupoEconomico}`);
        }
        if( (this.filterQuoteForm.value.inputIdEstatus) ) {
            paramsGet.push(`IdEstatus=${this.filterQuoteForm.value.inputIdEstatus}`);
        }
        if( typeof(this.filterQuoteForm.value.inputFechaDesde) == 'object' && this.filterQuoteForm.value.inputFechaDesde != null) {
            if(this.filterQuoteForm.value.inputFechaDesde.year){
                let date1 = Array(this.filterQuoteForm.value.inputFechaDesde.year, this.filterQuoteForm.value.inputFechaDesde.month,this.filterQuoteForm.value.inputFechaDesde.day).join('/')
                paramsGet.push(`FechaDesde=${date1}`);
            }
        }
        if( typeof(this.filterQuoteForm.value.inputFechaHasta) == 'object' && this.filterQuoteForm.value.inputFechaHasta != null) {
            if(this.filterQuoteForm.value.inputFechaHasta.year){
                let date2 = Array(this.filterQuoteForm.value.inputFechaHasta.year,this.filterQuoteForm.value.inputFechaHasta.month,this.filterQuoteForm.value.inputFechaHasta.day).join('/')
                paramsGet.push(`FechaHasta=${date2}`);
            }
        }
        if(this.permissionMenu.VerEvaluacionCotizacionVida == 1 && this.filterQuoteForm.value.inputAgente) {
            paramsGet.push(`Agente=${this.filterQuoteForm.value.inputAgente}`);
        }
        if(this.permissionMenu.VerEvaluacionCotizacionVida == 1 && this.filterQuoteForm.value.inputGrupoEconomico) {
            paramsGet.push(`Agente=${this.filterQuoteForm.value.inputGrupoEconomico}`);
        }

        return paramsGet.join('&');
    }

    submitNewquote() {
      this.quoteForm.patchValue({
        inputIdCotizacion: '',
        inputNroCotizacion : '',
        inputAsegurado : '',
        inputCedula: '',
        inputEdad: '',
        inputSexo: '',
        inputCelular: '',
        inputEsFumador: '',
        inputEmail: '',
        inputClasificacion:  this.Calificacion,
        inputTermino: '',
        inputTipoRiesgo: this.TipoRiesgo,
        inputUbicacionRiesgo : '',
        inputSumaAsegurada: '',
        inputSumaAseguraPolizaExistente: 0,
        inputSumaAseguradaContenido: 0.00,
        inputSumaAseguradaIncendio: 0.00,
        inputNroAnosPago: '',
        inputIdTipoPago: '',
        inputIdFrecuenciaPago: '',
        inputRecargo: this.Recargo,
        inputMotivoRecargo: '',
        inputIdTienePolizaVida: 2
      });

      this.quote_selected = null;
      this.quoteHasSuccess = 1;

      this.templateView = 2;
    }

    async submitQuote(content /*,target: HTMLElement*/) {
		var g = this;
		
		if(this.quoteForm.valid) {
			this.quoteHasErrorSubject.next(false);
			this.quoteResultSubject.next(null);
			this.modalLoading.open(content, this.loadingModalConfig);
			//
			//var dateFechaNacimiento = Array(this.quoteForm.value.inputFechaNacimiento.year,this.quoteForm.value.inputFechaNacimiento.month, this.quoteForm.value.inputFechaNacimiento.day).join('-');
			var data = {
				"IdCotizacion" : this.quoteForm.value.inputIdCotizacion || null,
				"Asegurado": this.quoteForm.value.inputAsegurado  || '',
                "Identificacion": this.quoteForm.value.inputIdentificacion || '',
				"Edad": parseInt(this.quoteForm.value.inputEdad),
				"IdSexo": this.quoteForm.value.inputSexo,
				"IdEsFumador": this.quoteForm.value.inputEsFumador,
				"Email": this.quoteForm.value.inputEmail  || '',
				"Celular": this.quoteForm.value.inputCelular  || '',
				"Clasificacion": this.quoteForm.value.inputClasificacion || this.Calificacion,
				"Termino": this.quoteForm.value.inputTermino,
				"SumaAsegurada": parseInt(this.quoteForm.value.inputSumaAsegurada),
				"SumaAseguradaIncendio": this.quoteForm.value.inputSumaAseguradaIncendio || 0,
				"SumaAseguradaContenido": this.quoteForm.value.inputSumaAseguradaIncendio > 0 ? this.quoteForm.value.inputSumaAseguradaContenido : 0,
				"UbicacionRiesgo": this.quoteForm.value.inputUbicacionRiesgo || this.UbicacionRiesgo,
				"Recargo": parseInt(this.quoteForm.value.inputRecargo) || this.Recargo,
				"IdTipoRiesgo": parseInt(this.quoteForm.value.inputTipoRiesgo) || 0,
				"NroAnosPago": parseInt(this.quoteForm.value.inputNroAnosPago),
				"IdFrecuenciaPago": parseInt(this.quoteForm.value.inputIdFrecuenciaPago),
				"IdTipoPago": parseInt(this.quoteForm.value.inputIdTipoPago),
                "MotivoRecargo": this.quoteForm.value.inputMotivoRecargo || '',
                "IdTienePolizaVida": this.IdTienePolizaVida ? 1 : 2,
                "SumaAseguraPolizaExistente" : 0
			};

            if(this.IdTienePolizaVida) {
                data.SumaAseguraPolizaExistente = parseInt(this.quoteForm.value.inputSumaAseguraPolizaExistente);
            }

            await this.quoteService.postQuote(data).then( (response: any) =>{
				if(typeof response[0] != undefined) {
					if(response[0].Success) {
						g.quoteResultSubject.next(response[0]);
                  
						g.quoteForm.patchValue({
							inputIdCotizacion : response[0].IdCotizacion,
                            inputNroCotizacion: response[0].IdCotizacion
						});

                        // Mod textos
                        var sel = (document.getElementById("inputIdFrecuenciaPago") as HTMLSelectElement);
                        this.FrecuenciaSelected = sel.options[sel.selectedIndex].text;
					}
					else {
						alert("No se pudo enviar la solicitud.");
					}
				} else {
					alert("No se pudo enviar la solicitud.");
          this.quoteHasErrorSubject.next(true);
				}
			}).finally(()=> {
				//g.targetDiv1.scrollToAnchor("view-result-quote");
				g.modalLoading.dismissAll();
			}).catch((reason: any)=>{
        this.quoteHasErrorSubject.next(true);
      });
		}else {
			this.modalLoading.dismissAll();
		}
  	}

    changeIdTienePolizaVida(event) {
        if(event.target.checked) {
            this.IdTienePolizaVida = true;
            this.quoteForm.patchValue({
                inputSumaAseguraPolizaExistente : 0
            });
            (document.getElementById("inputSumaAseguraPolizaExistente") as HTMLInputElement).disabled = false;
        }
        else {
            this.IdTienePolizaVida = false;
            this.quoteForm.patchValue({
                inputSumaAseguraPolizaExistente : 0
            });
            (document.getElementById("inputSumaAseguraPolizaExistente") as HTMLInputElement).disabled = true;
        }
        console.log("changeIdTienePolizaVida");
    }

    resetSubmitFilterQuote() {
      this.filterQuoteForm.reset( {"inputNroCotizacion" : ""} );
    }

    changeFrecuenciaPago() {
        if(parseInt(this.quoteForm.value.inputIdFrecuenciaPago) > 0) {
            this.findTipoPago(parseInt(this.quoteForm.value.inputIdFrecuenciaPago));
        }
    }

    async findTipoPago(IdFrecuenciaPago, selected = '') {
        this.helperServices.getTipoPago(
            "IdFrecuenciaPago=" + IdFrecuenciaPago
        ).then(response => {
            this.tipoPagoSubject.next(response);
            if(selected) {
                this.quoteForm.value.inputIdTipoPago = selected;
            }
        });
    }

    setQuoteValue(item) {

    	this.isNewQuote = false;

      	var dateFechaNacimiento = {
            year: parseInt(_moment(item.FechaNacimiento).format('yyyy'), 10),
            month: parseInt(_moment(item.FechaNacimiento).format('MM'), 10),
            day: parseInt(_moment(item.FechaNacimiento).format('DD'), 10)
        };

		this.quoteForm.patchValue({
			inputIdCotizacion: item.IdCotizacion || '',
			inputNroCotizacion : item.NroCotizacion,
			inputAsegurado : item.Asegurado,
            inputIdentificacion: item.Identificacion,
			//inputFechaNacimiento :  dateFechaNacimiento || '',
			inputEdad: item.Edad,
			inputSexo: item.IdSexo,
			inputCelular: item.Celular,
			inputEsFumador: item.IdEsFumador,
			inputEmail: item.Email,
			inputClasificacion: item.Clasificacion,
			inputTermino: item.Termino,
			inputTipoRiesgo: item.IdTipoRiesgo || 0,
			inputUbicacionRiesgo :item.UbicacionRiesgo || this.UbicacionRiesgo,
			//inputSumaAsegurada: this.currencyPipe.transform(item.SumaAsegurada,'$',false),
            inputSumaAsegurada:  (item.SumaAsegurada),
			inputSumaAseguradaContenido: (item.SumaAseguradaContenido),
			inputSumaAseguradaIncendio: (item.SumaAseguradaIncendio),
			inputNroAnosPago: item.NroAnosPago,
			inputIdTipoPago: item.IdTipoPago,
			inputIdFrecuenciaPago: item.IdFrecuenciaPago,
			inputRecargo: item.Recargo,
            inputMotivoRecargo: item.MotivoRecargo,
		});

        this.IdTienePolizaVida = item.IdTienePolizaVida==1  ? true : false;
        if(this.IdTienePolizaVida) {
            this.quoteForm.patchValue({ inputSumaAseguraPolizaExistente: (item.SumaAseguraPolizaExistente) });
            this.quoteForm.patchValue( { inputIdTienePolizaVida: true } );
            this.quoteForm.controls['inputSumaAseguraPolizaExistente'].enable();
        }
        else {
            this.quoteForm.patchValue({ inputSumaAseguraPolizaExistente: 0 });
            this.quoteForm.patchValue({ inputIdTienePolizaVida: false } );
            this.quoteForm.controls['inputSumaAseguraPolizaExistente'].disable();
        }

        if(parseInt(this.quoteForm.value.inputIdFrecuenciaPago))
            this.findTipoPago(parseInt(this.quoteForm.value.inputIdFrecuenciaPago), this.quoteForm.value.IdTipoPago);

		if(item.PrimaAnualBasicaSeguroVida > 0) {
            this.quoteResultSubject.next({
                PrimaAnualBasicaSeguroVida: this.quote_selected.PrimaAnualBasicaSeguroVida || 0.00,
                RecargoAnualAgravacionRiesgo: this.quote_selected.RecargoAnualAgravacionRiesgo || 0.00,
                PrimaAnualAdicionalSeguroVida: this.quote_selected.PrimaAnualAdicionalSeguroVida || 0.00,
                PrimaAnualBasicaBeneficiosAdicinales: this.quote_selected.PrimaAnualBasicaBeneficiosAdicinales || 0.00,
                PrimaMensualTotalNivelada: this.quote_selected.PrimaMensualTotalNivelada || 0.00,
                PrimaAnualTotalNivelada: this.quote_selected.PrimaAnualTotalNivelada || 0.00,
                PrimaAnualAnosPagos: this.quote_selected.PrimaAnualAnosPagos || 0.00,
                PrimaMensualAnosPagos: this.quote_selected.PrimaMensualAnosPagos || 0.00,
                RecargoAnualFormaPago: (this.quote_selected.RecargoAnualFormaPago) > 0 ? this.quote_selected.RecargoAnualFormaPago : 0.00,
            });
		}
		else {
			this.quoteResultSubject.next(null);
		}
        
        this.frecuenciaPago.then(response => {
            var frecuencia = _.findWhere(response, { "IdFrecuenciaPago" : item.IdFrecuenciaPago.toString() });
            this.FrecuenciaSelected = frecuencia.FrecuenciaPago;
        });
    }

    async downloadDocumentQuote(content, IdCotizacion) {
      this.modalLoading.open(content, this.loadingModalConfig);
      this.quoteService.getDocumentQuote("IdCotizacion=" + IdCotizacion).then(response => {
        if(response) {
           this.helperServices.printPreview2(response, `Cotizacion-${IdCotizacion}.pdf`, "application/pdf");
        }
        else {
          alert("No se pudo generar el documento.")
        }

      }).finally(() => {
        this.modalLoading.dismissAll();
      })
    }
  
    // pagination
    paginate(paginator: PaginatorState) {
      this.quoteService.patchState({ paginator });
    }

    getRequiredDocument() {
        this.quoteService.getRequiredDocument(`IdCotizacion=${this.quoteForm.value.inputIdCotizacion}`).then( (response:QuoteDocuments[]) => {
            if(response) {
                this.requiredDocumentSubject.next(response);
            }
        }).finally(() => {
            this.hasLoadindRD = false;
        });
    }

    onclickModalUploadRequiredDocument(content) {
      this.hasLoadindRD = true;

        this.modalRequiredDocumentos.open(content, this.loadingModalConfig).result.then((result) => {
        }, (reason) => { // this.getDismissReason(reason)
            this.hasLoadindRD = false;
        });

        this.quoteService.getRequiredDocument(`IdCotizacion=${this.quoteForm.value.inputIdCotizacion}`).then( (response:QuoteDocuments[]) => {
            if(response) {
                this.requiredDocumentSubject.next(response);
            }
        }).finally(() => {
            this.hasLoadindRD = false;
        });

    }

    onclickModalRequiredDocument(content) {
        this.hasLoadindRD = true;

        this.modalRequiredDocumentos.open(content, this.loadingModalConfig).result.then((result) => {
        }, (reason) => { // this.getDismissReason(reason)
            this.hasLoadindRD = false;
        });

        this.quoteService.getRequiredDocument(`IdCotizacion=${this.quoteForm.value.inputIdCotizacion}`).then( (response:QuoteDocuments[]) => {
            if(response) {
                this.requiredDocumentSubject.next(response);
            }
        }).finally(() => {
            this.hasLoadindRD = false;
        });
    }

    onclickUploadRequiredDocument(content, IdTipoDocumento) {
        if( ! (document.getElementById(`file${IdTipoDocumento}`) as HTMLInputElement).files[0] ) {
            alert("Debe seleccionar un documento para poder subirlo");
        }
        else {
            this.hasLoadindRD = true;

            var params = {
                "IdCotizacion" : this.quoteForm.value.inputIdCotizacion,
                "IdTipoDocumento" : IdTipoDocumento,
                "file" : `file${IdTipoDocumento}`
            };

            this.quoteService.postUploadRequiredDocument(params).then(response => {
                this.hasLoadindRD = false;

                if(response) {
                    this.getRequiredDocument();
                }
                else {
                    alert(response[0].Error);
                }
                
            }).finally(() => {
                this.hasLoadindRD = false;
            })
        }
    }

    onclickViewUploadRequiredDocument(content, IdTipoDocumento) {
      this.quoteService.downloadMyRequiredDocument(`IdCotizacion=${this.quoteForm.value.inputIdCotizacion}&IdTipoDocumento=${IdTipoDocumento}`).then(response => {
          if(typeof(response[0].Documento) != "undefined") {
            this.helperServices.printPreview3(response[0].Documento, response[0].NameDoc, "application/pdf");
          }
          else {
            alert("No se pudo descarga el documento.")
          }
        }).finally(()=> {
          
        });
    }

    clickDownloadRequiredDocument(content, id) {
      this.modalLoading.open(content, this.loadingModalConfig);
      this.quoteService.downloadRequiredDocument("IdTipoDocumento=" + id).then(response => {
        if( typeof(response[0].Documento) != undefined) {
          this.helperServices.printPreview3(response[0].Documento, response[0].NameDoc);
        }
        else {
          alert("No se pudo descarga el documento.")
        }
      }).finally(()=> {
        this.modalLoading.dismissAll();
      });
    }

    onclickRequestQuote(content) {
        this.modalLoading.open(content, this.loadingModalConfig);

        this.quoteService.getRequiredDocument(`IdCotizacion=${this.quoteForm.value.inputIdCotizacion}`).then( async (response : any) => {
            var successEmision = true;
            response.forEach(e => {
                if(parseInt(e.Cargado)==2 && parseInt(e.Requerido)==1 )successEmision = false;
            });
            if(successEmision) {
                await this.quoteService.postEmisionQuote({IdCotizacion:this.quoteForm.value.inputIdCotizacion}).then(response => {
                    if(response[0].Success) { alert("Solicitud Enviada"); }
                    else { alert(response[0].Mensaje); }
                }).catch(() => { alert("No se pudo mandar la solicitud."); });
            }
            else {
                alert("Para realizar una solicitud debe cargar todos los documentos requeridos.");
            }
        }).finally(()=>{
            this.modalLoading.dismissAll();
        }).catch(() => { alert("No se pudo mandar la solicitud."); });
    }
    
    // Enviar solicitud de aprobación solo para Aseguradora.
    onclickModifyQuote(content) {
        this.modalLoading.open(content, this.loadingModalConfig);

        this.quoteService.postModifyQuote({IdCotizacion:this.quoteForm.value.inputIdCotizacion}).then( async response => {
            if(response[0].Success) {
                alert("Se envió la solicitud de aprobación.");
            }
            else {
                alert(response[0].Mensaje);
            }
        }).finally(()=>{
            this.modalLoading.dismissAll();
        }).catch(() => { alert("No se pudo procesar la solicitud."); });
    }

    // Emitir póliza solo para Aseguradora.
    onclickAppovalQuote(content) {
        this.modalLoading.open(content, this.loadingModalConfig);

        this.quoteService.postApprovalQuote({IdCotizacion:this.quoteForm.value.inputIdCotizacion}).then( async response => {
            if(response[0].Success) {
                alert("Se envío la solicitud de emisión.");
            }
            else {
                alert(response[0].Mensaje);
            }
        }).finally(()=>{
            this.modalLoading.dismissAll();
        }).catch(() => { alert("No se pudo solicitar la emisión."); });
    }

    number(prms: any): ValidatorFn {
      return (control: FormControl): {[key: string]: any} => {
                
        let val: number = control.value;
  
        if(isNaN(val) || /\D/.test(val.toString())) {
          
          return {"number": true};
        } else if(!isNaN(prms.min) && !isNaN(prms.max)) {
          
          return val < prms.min || val > prms.max ? {"number": true} : null;
        } else if(!isNaN(prms.min)) {
          
          return val < prms.min ? {"number": true} : null;
        } else if(!isNaN(prms.max)) {
          
          return val > prms.max ? {"number": true} : null;
        } else {
          
          return null;
        }
      };
    }

    openSite(siteUrl) {
      window.open("./" + siteUrl, '_blank');
    }

    money(value, currency = '', format =  '1.0-0' ) {
        return this.currencyPipe.transform(value,currency,false, format);
    }
  }
  